import { Middleware } from 'redux';
import { AGREEMENT_OBJECT, RENTAL_OBJECT } from 'core/datasets/action';
import { parseSelectedRentalAgreementValidFromDate } from 'tenantUser/utils/parseSelectedRentalAgreementValidFromDate';
import { rentalObjectsActions } from '../rentalObjectActions';
import { queryMeterReadings } from 'meterReading/gql/queryMeterReadings';
import CHART_X_UNIT from 'meterReading/datasets/chart_x_unit';
import { getMeterLinksData } from 'rentalObject/utils/getMeterLinksData';

const rentalObjectMiddleware: Middleware =
    ({ dispatch, getState }) =>
    (next) =>
    (action) => {
        next(action);

        switch (action?.type) {
            case RENTAL_OBJECT.REQUEST_METER_READINGS_DATA_INTO_STORE: {
                const { objectId, date, range } = action.payload;
                if (!objectId) return;

                let fromDate = range?.fromDate || null;
                if (!fromDate) {
                    const parsedValidFrom = parseSelectedRentalAgreementValidFromDate(date || '');
                    if (parsedValidFrom) {
                        fromDate = parsedValidFrom.minus({ months: 2 }).startOf('month').toSQLDate();
                    }
                }

                const options = {
                    rentalObjectId: objectId,
                    ...(fromDate && { range: { fromDate, toDate: range?.toDate || null } }),
                };

                dispatch(
                    rentalObjectsActions.fetchMeterReadings(
                        queryMeterReadings,
                        options,
                        RENTAL_OBJECT.RECEIVE_METER_READINGS,
                    ),
                );
                break;
            }

            case RENTAL_OBJECT.RECEIVE_METER_READINGS: {
                const { payload } = action;
                const meterReadingsData = payload.data?.meterReadings || [];
                const selectedObjectID = getState().agreementObjects.selectedObjectID;

                dispatch(rentalObjectsActions.putMeterReadingsData(meterReadingsData));
                dispatch(
                    rentalObjectsActions.setChartsData({
                        metersData: meterReadingsData,
                        chartsUnit: CHART_X_UNIT.MONTH,
                        meterChartsLinks: getMeterLinksData(meterReadingsData, selectedObjectID as number),
                    }),
                );
                break;
            }

            case AGREEMENT_OBJECT.AGREEMENT_OBJECT_SELECTED: {
                dispatch(rentalObjectsActions.cleanChartsData());
                break;
            }

            case RENTAL_OBJECT.SET_CHARTS_DATA: {
                const { payload } = action;
                localStorage.setItem('rentalObjects', JSON.stringify({ chartsDataSet: payload }));
                break;
            }

            default:
                break;
        }
    };

export default rentalObjectMiddleware;
